import { render, staticRenderFns } from "./divarNewsList.vue?vue&type=template&id=98c0eb80&scoped=true"
import script from "./divarNewsList.vue?vue&type=script&lang=js"
export * from "./divarNewsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c0eb80",
  null
  
)

export default component.exports